import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { MD, ASSETS } from "../../data/content";

export const Leadership = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="leadership" className="relative py-24 md:py-40 border-t border-brand-line bg-brand-surface/40" data-testid="leadership-section" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="overline mb-6">04 — Leadership</p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-20 items-start">
          {/* Text */}
          <Reveal className="order-2 lg:order-1">
            <blockquote className="font-display text-3xl md:text-5xl font-light text-brand-text leading-[1.08] tracking-tight">
              <span className="text-brand">“</span>{MD.quote}<span className="text-brand">”</span>
            </blockquote>

            <div className="mt-8 flex items-center gap-3">
              <span className="w-2.5 h-2.5 rounded-full bg-brand-red" />
              <div>
                <p className="text-brand-text text-lg">{MD.name}</p>
                <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-brand-soft mt-1">{MD.role}</p>
              </div>
            </div>

            <div className="mt-10 space-y-5 max-w-xl">
              {MD.bio.map((p, i) => (
                <p key={i} className="text-brand-soft font-light leading-relaxed">{p}</p>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-2.5">
              {MD.credentials.map((c) => (
                <span key={c} className="px-4 py-2 border border-brand-line font-mono text-[10px] uppercase tracking-[0.15em] text-brand-soft hover:border-brand hover:text-brand transition-colors duration-300">
                  {c}
                </span>
              ))}
            </div>
          </Reveal>

          {/* Portrait — deliberate clipped frame, grayscale to color */}
          <Reveal className="order-1 lg:order-2" delay={0.15}>
            <div className="relative">
              <span className="absolute -top-4 left-0 font-mono text-[10px] uppercase tracking-[0.25em] text-brand-muted">Principal / CEO</span>
              <div className="relative aspect-[4/5] overflow-hidden border border-brand-line group">
                <motion.img
                  style={{ y }}
                  src={ASSETS.md}
                  alt={MD.name}
                  data-testid="md-portrait"
                  className="w-full h-[116%] object-cover object-top grayscale group-hover:grayscale-0 transition-[filter] duration-700 scale-105"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-brand/10 pointer-events-none" />
                <div className="absolute bottom-0 inset-x-0 h-24 bg-gradient-to-t from-brand-base/70 to-transparent" />
              </div>
              <div className="absolute -bottom-3 -right-3 w-16 h-16 border-r border-b border-brand" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Leadership;
